import { render, staticRenderFns } from "./Return.vue?vue&type=template&id=556a6697&scoped=true&"
import script from "./Return.vue?vue&type=script&lang=ts&"
export * from "./Return.vue?vue&type=script&lang=ts&"
import style0 from "./Return.vue?vue&type=style&index=0&id=556a6697&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a6697",
  null
  
)

export default component.exports